import { jsx } from "panel";
import { BannerEl } from "common/components/banner";
import { BannerAction } from "common/components/banner/types";
export function template() {
  const {
    visible
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-message-banner-container", class: {
    "mp-message-banner-visible": visible
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, visible && /* @__PURE__ */ jsx(BannerEl, { theme: this.attr(`type`), headerText: this.attr(`title`), bodyText: this.attr(`message`), size: this.attr(`size`), ctas: this.attr(`closeable`) ? [{
    text: `Dismiss`,
    actionName: BannerAction.Dismiss
  }] : [], onAction: this.helpers.hideBanner }));
}
